import React, { useState, useEffect } from "react";
import { API } from "../../config/api";

export default function AdsPlanManager() {
  const [plans, setPlans] = useState([]);

  const [form, setForm] = useState({
    type: "machine",
    days: "",
    amount: "",
  });

  const [editId, setEditId] = useState(null);

  const [loading, setLoading] = useState(false);

  // ================= Fetch Plans =================

  const fetchPlans = (type = form.type) => {
    fetch(`${API.GET_ADS_PLANS}&type=${type}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setPlans(data.data);
        } else {
          setPlans([]);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchPlans(form.type);
  }, [form.type]);

  // ================= Handle Change =================

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // ================= Submit =================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.days || !form.amount) {
      alert("All fields are required");
      return;
    }

    setLoading(true);

    try {
      const url = editId ? API.UPDATE_ADS_PLAN : API.ADD_ADS_PLAN;

      const payload = editId
        ? {
            id: editId,
            type: form.type,
            days: form.days,
            amount: form.amount,
          }
        : {
            type: form.type,
            days: form.days,
            amount: form.amount,
          };

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        alert(editId ? "Plan Updated Successfully" : "Plan Added Successfully");

        setForm({
          type: form.type,
          days: "",
          amount: "",
        });

        setEditId(null);

        fetchPlans(form.type);
      } else {
        alert(data.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);
      alert("Server Error");
    }

    setLoading(false);
  };

  // ================= Delete =================

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this plan?")) return;

    try {
      const res = await fetch(API.DELETE_ADS_PLAN, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });

      const data = await res.json();

      if (data.status) {
        fetchPlans(form.type);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ================= Edit =================

  const handleEdit = (plan) => {
    setForm({
      type: plan.type || form.type,
      days: plan.days,
      amount: plan.amount,
    });

    setEditId(plan.id);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="workspace-container">
      <h2>Ads Plan Manager</h2>

      <div className="ads-layout">
        {/* ================= FORM ================= */}

        <div className="ads-form-card">
          <h3>{editId ? "Update Plan" : "Add Plan"}</h3>

          <form onSubmit={handleSubmit}>
            {/* Type */}

            <div className="workspace-field">
              <label>Plan Type</label>

              <select name="type" value={form.type} onChange={handleChange}>
                <option value="machine">Machine</option>

                {/* <option value="supplier">Supplier</option> */}

                <option value="workspace">Workspace</option>
              </select>
            </div>

            {/* Days */}

            <div className="workspace-field">
              <label>Days</label>

              <input
                type="number"
                name="days"
                value={form.days}
                onChange={handleChange}
                placeholder="Enter Days"
                min="1"
              />
            </div>

            {/* Amount */}

            <div className="workspace-field">
              <label>Amount (₹)</label>

              <input
                type="number"
                name="amount"
                value={form.amount}
                onChange={handleChange}
                placeholder="Enter Amount"
                min="0"
              />
            </div>

            <button className="machine-submit-btn mt-3">
              {loading ? "Saving..." : editId ? "Update Plan" : "Add Plan"}
            </button>

            {editId && (
              <button
                type="button"
                className="btn btn-secondary ms-2 mt-3"
                onClick={() => {
                  setEditId(null);

                  setForm({
                    type: form.type,
                    days: "",
                    amount: "",
                  });
                }}
              >
                Cancel
              </button>
            )}
          </form>
        </div>

        {/* ================= TABLE ================= */}

        <div className="ads-table-card">
          <h3>
            {form.type.charAt(0).toUpperCase() + form.type.slice(1)} Ads Plans
          </h3>

          <div className="ad-table-scroll">
            <table className="ad-table1">
              <thead>
                <tr>
                  <th>#</th>

                  <th>Days</th>

                  <th>Amount</th>

                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {plans.length === 0 ? (
                  <tr>
                    <td colSpan="4">No Plans Found</td>
                  </tr>
                ) : (
                  plans.map((plan, index) => (
                    <tr key={plan.id}>
                      <td>{plans.length - index}</td>

                      <td>{plan.days} Days</td>

                      <td>₹{plan.amount}</td>

                      <td className="action-cell">
                        <button
                          type="button"
                          className="ad-icon-btn ad-edit"
                          onClick={() => handleEdit(plan)}
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>

                        <button
                          type="button"
                          className="ad-icon-btn ad-delete"
                          onClick={() => handleDelete(plan.id)}
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
